import { Box, IconButton, Snackbar } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React, { SetStateAction, useState } from "react";
import { generateIframeBubbleCode } from "../../../Shared-ui/utils/Common/Common";
import { RedirectUrl } from "../../../Constant/Setting";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import variables from "../../../assets/styles/variables.module.scss";
import { Agent } from "../../../Shared-ui/Types/Agent";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";
import { WorkflowListItem } from "../../../Services/WorkflowService";

interface MyComponentProps {
  agent?: Agent;
  multiAgent?: MultiAgent;
  workflow?: WorkflowListItem;
  tabId: number;
  setTabId: React.Dispatch<SetStateAction<number>>;
}

const Embedings: React.FC<MyComponentProps> = (props) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  console.log(
    "Embedings component rendered with agent 2:", props.agent, "multiAgent:", props.multiAgent, "and workflow:", props.workflow
  );

  const handleCopy = () => {
    let code = "";
    if (props.agent) {
      code = generateIframeBubbleCode(RedirectUrl, props.agent, "iframeAgent");
    } else if (props.multiAgent) {
      code = generateIframeBubbleCode(RedirectUrl, props.multiAgent, "iframeMultiAgent");
    } else if (props.workflow) {
      code = generateIframeBubbleCode(RedirectUrl, props.workflow, "iframeWorkflow");
    }
    navigator.clipboard.writeText(code);
    setOpenSnackbar(true);
  }

  return (
    <>
      <Box
        sx={{
          position: "relative",
          borderRadius: "8px",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
          }}
        >
          <IconButton
            onClick={handleCopy}
            size="small"
            sx={{
              color: "#fff",
              "&:hover": {
                color: variables.primaryColor,
              },
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Box>
        <SyntaxHighlighter
          language="html"
          style={atomOneDark}
          customStyle={{
            margin: 0,
            padding: "16px",
            borderRadius: "8px",
            fontSize: "14px",
          }}
          wrapLongLines={true}
        >
          {generateIframeBubbleCode(
            RedirectUrl,
            props.agent || props.multiAgent || props.workflow || ({} as Agent),
            props.agent?.id ? "iframeAgent" : props.multiAgent?.id ? "iframeMultiAgent" : "iframeWorkflow"
          )}
        </SyntaxHighlighter>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        message="Code copied to clipboard"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

export default Embedings;